<template>
  <div>
    <div class="foot ty-wz">
      <div class="foot-child" :style="getBjtp1('foot-bg.jpg')">
        <div class="container">
          <div style="display: flex; justify-content: space-evenly">
            <span style="display: block;width: 200px;">{{ $t("footer6") }}</span>
            <span style="display: block;width: 200px;">{{ $t("footer13") }}</span>
            <span style="display: block;width: 200px;">{{ $t("footer14") }}</span>
          </div>
          <img
            class="code"
            src="/imgs/code.png"
            alt=""
          />
          <!-- <p>{{ $t("扫码点击 “报名通道” 选择 “Pharmax” 报名") }}</p> -->
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 10px;
            "
          >
            <span>
              <!-- {{ $t("footer3") }} -->
            </span>
            <span>{{ $t("Email") }}：mkt@huiyuexpo.com</span>
            <span>
              <!-- {{ $t("Phone") }}：+86 131 6708 2378 -->
            </span>
          </div>
          <p>
            © 2023 HUIYU EXHIBITION (SHANGHAI) CO.,LTD. &nbsp;{{
              $t("会誉会展（上海）有限公司")
            }}
          </p>
        </div>
        <!-- <div class="foot-item item1">
          <img :src="fileServerUrl + 'assets/phamax/pha-footIcon.png'" />
          <div class="foot-wz">
            <a href="/">{{ $t("footer1") }}</a>
            <a href="http://www.soldout.tech/#/" target="_blank">{{
              $t("footer2")
            }}</a>
            <a href="http://www.itall.tech/#/" target="_blank">{{
              $t("footer3")
            }}</a>
            <a href="http://www.logtalk.huiyuexpo.com/#/" target="_blank">{{
              $t("footer4")
            }}</a>
          </div>
        </div>

        <hr class="hr-dashed-fixed" />
        <div class="foot-item item2">
          <div class="zzyzs-top ty-flex">
            <span style="font-weight: bold; color: rgb(31, 163, 209)">{{
              $t("footer5")
            }}</span>
            <span>Winston Ma</span>
            <span>+86-21-61671521</span>
            <span>winston.ma@huiyuexpo.com</span>
          </div> -->
        <!-- <div class="zzyzs-bottom ty-flex">
            <span style="font-weight: bold; color: rgb(31, 163, 209)">{{
              $t("footer6")
            }}</span>
            <span>Kevin Wan</span>
            <span>+86-21-61671495</span>
            <span>kevin.wan@huiyuexpo.com</span>
          </div> -->
        <!-- </div> -->

        <!-- <div class="foot-item item2">
          <div class="zzyzs-top ty-flex">
            <span style="font-weight: bold; color: rgb(31, 163, 209)">{{
              $t("footer7")
            }}</span>
            <span>Max Zeng</span>
            <span>+86-21-60126549</span>
            <span> max.zeng@huiyuexpo.com</span>
          </div> -->
        <!-- <div class="zzyzs-bottom ty-flex">
            <span style="font-weight: bold; color: rgb(31, 163, 209)">{{
              $t("footer8")
            }}</span>
            <span>Daniel Han</span>
            <span>+86-21-61155896</span>
            <span>daniel.han@huiyuexpo.com</span>
          </div> -->
        <!-- </div>

        <hr class="hr-dashed-fixed2" />

        <div class="foot-item">
          <div class="smgz">
            <div class="ty-flex smgz-top">
              <span>{{ $t("footer9") }}</span>
              <span style="margin-top: 5px">{{ $t("footer10") }}</span>
            </div>
            <div class="smgz-bottom">
              <img :src="fileServerUrl + 'assets/phamax/gzhEW.jpg'" />
            </div>
          </div>
        </div> -->
      </div>
      <!-- <div class="foot-bottom">
        <div class="foot-bottom-wz">
          <span>会誉会展（上海）有限公司</span>
          <span>© 2023 HUIYU EXHIBITION (SHANGHAI) CO.,LTD.</span>

          <a
            style="margin-left: 5%; color: white"
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702007599"
          >
            沪公网安备 31010702007598号
          </a>

          <a
            href="https://beian.miit.gov.cn/"
            style="margin-left: 2%; color: white"
            >沪ICP备 2020038301号-2</a
          >
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileServerUrl: fileServerUrl,
    };
  },
  methods: {
    getBjtp1(name) {
      let ys = {
        backgroundImage:
          "url(" + this.fileServerUrl + "assets/phamax/" + name + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
        // backgroundColor:'#524AF6FF',
        backgroundPosition: "center",
      };
      return ys;
    },
  },
};
</script>

<style lang="scss" scoped>
  .container {
    padding: 10px 0 5px 0;
    width: 60%;
    margin: 0 auto;
    text-align: center;
    .code {
      margin: 10px auto 0px auto;
    }
  }
.hr-dashed-fixed {
  width: 0.009rem;
  height: 120px;
  border: 0;
  padding-top: 0.4px;
  background: repeating-linear-gradient(
    to top,
    rgb(31, 163, 209) 8px,
    rgb(31, 163, 209) 12px,
    transparent 12px,
    transparent 14px
  );
  position: absolute;
  margin-top: 23px;
  left: 28%;
}

.hr-dashed-fixed2 {
  width: 0.009rem;
  height: 120px;
  border: 0;
  padding-top: 0.4px;
  background: repeating-linear-gradient(
    to top,
    rgb(31, 163, 209) 8px,
    rgb(31, 163, 209) 12px,
    transparent 12px,
    transparent 14px
  );
  position: absolute;
  margin-top: 23px;
  right: 30%;
}

.foot-child {
  width: 100%;
  // height: 150px;
  display: flex;
}

.foot-item {
  width: 120px;
  height: 123px;
  margin-top: 25px;
  margin-left: 40px;
  //border: 1px solid red;
  display: flex;
  flex-direction: column;
}

.foot-item img {
  width: 70px;
  height: 13px;
}

.foot-wz {
  margin-top: 20px;
  width: 100%;
  height: 70px;
  display: flex;
  font-size: 0.095rem;
  flex-direction: column;
  justify-content: space-around;
  //border: 1px solid darkmagenta;
  a {
    color: white;
  }
}

.foot-bottom {
  width: 100%;
  height: 30px;
  font-size: 0.09rem;
  display: flex;
  align-items: center;

  background-color: rgb(31, 163, 209);
}

.foot-bottom-wz {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  //border: 0.1px solid red;
}

.item1 {
  margin-left: 93px;
}
.item2 {
  margin-left: 33px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.zzyzs-top {
  width: 100%;
  height: 50px;
  font-size: 0.095rem;
  //border: 1px solid #424cf9;
}
.zzyzs-bottom {
  width: 100%;
  height: 50px;
  font-size: 0.095rem;
  //border: 1px solid #0239be;
  margin-top: 13px;
}

.smgz {
  width: 65%;
  height: 85%;
  background-color: rgb(31, 163, 209);
}

.smgz-top {
  width: 100%;
  height: 30%;
  //border: 1px solid red;
  font-size: 0.12rem;
  color: black;
  font-family: "阿里妈妈数黑体 Bold";
  text-align: center;
  justify-content: center;
}

.smgz-bottom {
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: center;
  //border: 1px solid red;
}
.smgz-bottom img {
  width: 88%;
  height: 88%;
}

.ty-flex {
  display: flex;
  flex-direction: column;
}

.ty-wz {
  color: white;
  font-family: PuHuiTi;
  font-size: 0.11rem;
}
</style>
